/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .constant('FILE_UPLOAD_MODAL_EVENT', {
        CLOSED: 'fileUploadModal.closed'
    })
    .factory('FileUploadModal', [
        '$modal',
        '$rootScope',
        '$translate',
        'FILE_UPLOAD_MODAL_EVENT',
        'Uploader',
        function ($modal, $rootScope, $translate, FILE_UPLOAD_MODAL_EVENT, Uploader) {
            var modal = null;
            var modalPromise = null;

            /**
             * Create and show modal upload window
             * 
             * @param {Resource} folder - Target folder to upload
             * @param {(FileList|File[])} [files=[]] - List of files to upload
             * @return {Promise} Promise to be resolved once the uploading has been completed and modal is closed
             */
            return function (folder, files) {
                if (files) {
                    Uploader.addToQueue(files, false);
                }

                /**
                 * If we call this service 2nd time, while the modal is opened
                 * files will be just appended to the current upload queue.
                 * (!) There is no way to update target folder in this case.
                 * Appended files will be uploaded to the previously selected folder.
                 */
                if (modal != null) {
                    return modalPromise;
                }

                /**
                 * We need to pass folder into modal controller.
                 * In order to do that, we'll create a new scope
                 * and save folder into it.
                 */
                var modalScope = $rootScope.$new();
                modalScope.folder = folder;

                modal = $modal.open({
                    domOptions: {
                        modalTitle: ($translate.instant('Upload to') + " '" + folder.name + "'"),
                        modalBodyTemplate: 'modals/actions/upload',
                        modalFooterTemplate: 'nodes/_upload_modal_footer',
                        modalNotifications: true
                    },
                    size: 'lg',
                    windowClass: 'upload-dialog',
                    controller: 'FileUploadModalController',
                    backdrop: 'static',
                    scope: modalScope,
                    keyboard: false
                });

                modalPromise = modal.result.then(function (stat) {
                    modal = null;
                    $rootScope.$broadcast(FILE_UPLOAD_MODAL_EVENT.CLOSED, stat);
                    $rootScope.$broadcast('reload.contentStats');
                });

                return modalPromise;
            };
        }]);
